import Distribucio from "../../model/menudesign/Distribucio";


const apiUrl = process.env.REACT_APP_API_URL;
export const PostDistribucio = async (page: string, distribucion: Distribucio, id_usu_log: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/proveidors/distribucio/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(distribucion)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};